import { render, staticRenderFns } from "./NewsDetailsPage.vue?vue&type=template&id=7aeafaba&scoped=true&"
import script from "./NewsDetailsPage.vue?vue&type=script&lang=js&"
export * from "./NewsDetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./NewsDetailsPage.vue?vue&type=style&index=0&id=7aeafaba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aeafaba",
  null
  
)

export default component.exports